import React, { useEffect, useState } from "react";

const Footer = () => {
  const [companyName, setCompanyName] = useState("Sarvajna");

  useEffect(() => {
    const name = localStorage.getItem("companyName");
    if (name) {
      setCompanyName(name);
    }
  }, []);

  return (
    <div className="dashboard-footer">
      <div className="flex-between flex-wrap gap-16">
        <div style={{ color: "black", fontSize: "12px" }}>
          &copy; Copyright {companyName} 2025, All Right Reserved
        </div>

        <div className="flex-align flex-wrap gap-16">
          <a
            href="https://beingmash.com/"
            className="hover-text-main-600 hover-text-decoration-underline"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "black", fontSize: "12px" }}
          >
            Developed by: BeingMash Services Pvt Ltd
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;